import React from 'react';

import { LabelList, PolarAngleAxis, PolarRadiusAxis, RadialBar, RadialBarChart } from 'recharts';

import dashboardAvatar from '../../../../assets/dashboardAvatar.png';

const calcCoordinates = (x, y, value, line) => {
  if (line === 0) {
    if (value > 0 && value <= 25) {
      return { x: x - 5, y: y };
    } else if (value > 25 && value <= 50) {
      return { x: x, y: y - 5 };
    } else if (value > 50 && value <= 75) {
      return { x: x + 5, y: y };
    } else if (value > 75 && value < 90) {
      return { x: x + 5, y: y };
    } else if (value >= 90 && value <= 100) {
      return { x: x, y: y + 15 };
    } else {
      return { x: x, y: y };
    }
  } else {
    if (value >= 90 && value <= 100) {
      return { x: x, y: y - 15 };
    } else {
      return { x: x, y: y };
    }
  }
};

const calculatePointOnCircle = (centerX, centerY, radius, angleInDegrees) => {
  const angleInRadians = -angleInDegrees * (Math.PI / 180);
  const x = centerX + radius * Math.cos(angleInRadians);
  const y = centerY + radius * Math.sin(angleInRadians);
  
  return { x, y };
};

const renderCustomizedLabel = props => {
  const { index, value, fill, viewBox } = props;
  const { cx, cy, innerRadius, outerRadius, endAngle } = viewBox;
  
  const radius = (innerRadius + outerRadius) / 2;
  const labelAngle = index === 0 ? endAngle - 20 : endAngle - 15;
  
  const { x: dotX, y: dotY } = calculatePointOnCircle(cx, cy, radius, endAngle);
  const { x: textX, y: textY } = calculatePointOnCircle(cx, cy, radius, labelAngle);
  
  const { x: coordinateX, y: coordinateY } = calcCoordinates(textX, textY, value, index);
  
  return (
    <g>
      <circle cx={dotX} cy={dotY} r={5} fill={fill}/>
      <text x={coordinateX} y={coordinateY} textAnchor="middle" dominantBaseline="middle"
            className="text-[11px] font-medium leading-[18px] tracking-normal text-[#262626]">
        {value}%
      </text>
    </g>
  );
};

const RadialChart = ({ type, data, title }) => {
  return (
    <div className="flex flex-col items-center gap-y-6">
      {title && <span className="text-center text-lg font-medium leading-6 tracking-normal">{title}</span>}
      <RadialBarChart
        width={220}
        height={200}
        data={data}
        barCategoryGap={30}
        startAngle={90}
        endAngle={-270}
        innerRadius={'75%'}
        outerRadius={'100%'}
        barSize={3}
        className="[&>svg]:overflow-visible"
      >
        <PolarRadiusAxis axisLine={false} tick={false} scale="linear"/>
        <PolarAngleAxis type="number" domain={[0, 100]} angleAxisId={0} tick={false} tickLine={false}/>
        <RadialBar minAngle={90} background clockWise dataKey="value">
          <LabelList content={renderCustomizedLabel}/>
        </RadialBar>
        
        <g transform={`translate(${110},${100})`}>
          {type === 'text' ? (
            <text textAnchor="middle" dominantBaseline="middle" className="text-[32px] font-medium leading-[42px] tracking-normal text-[#262626]">
              {data[1].value}%
            </text>
          ) : (
            <image x={-40} y={-40} href={dashboardAvatar}/>
          )}
        </g>
      </RadialBarChart>
    </div>
  );
};

export default RadialChart;
